import { createMuiTheme } from "@material-ui/core/styles";
import { Currency, Priority, PriorityValue } from "types";
import { PRIO1, PRIO2, PRIO3, PRIMARY_MAIN } from "utils/colors";
import { grey } from "@material-ui/core/colors";

export const TOAST_AUTO_HIDE_DURATION = 4000;
export const LOCAL_STORAGE_KEY = "knboard-data";

export const grid = 8;
export const borderRadius = 4;
export const imageSize = 40;
export const barHeight = 50;
export const sidebarWidth = 120;
export const taskHeaderTextareaWidth = 180;
export const taskWidth = 350;
export const taskSideWidth = 220;
export const taskDialogHeight = 800;
export const commentBoxWidth = 390;
export const commentBoxWidthMobile = 300;

export const PRIORITY_1: Priority = { value: "H", label: "High" };
export const PRIORITY_2: Priority = { value: "M", label: "Medium" };
export const PRIORITY_3: Priority = { value: "L", label: "Low" };

export const PRIORITY_OPTIONS: Priority[] = [
  PRIORITY_1,
  PRIORITY_2,
  PRIORITY_3,
];

export const PO_RELEASED_STATUS = "PURCHASE_ORDER_RELEASED";

export const CURRENCY_1: Currency = { value: "USD", label: "USD" };
export const CURRENCY_2: Currency = { value: "EUR", label: "EUR" };
export const CURRENCY_3: Currency = { value: "GBP", label: "GBP" };
export const CURRENCY_4: Currency = { value: "INR", label: "INR" };
export const CURRENCY_5: Currency = { value: "AUD", label: "AUD" };
export const CURRENCY_6: Currency = { value: "CAD", label: "CAD" };
export const CURRENCY_7: Currency = { value: "THB", label: "THB" };
export const CURRENCY_8: Currency = { value: "AED", label: "AED" };
export const CURRENCY_9: Currency = { value: "CNY", label: "CNY" };

export const CURRENCY_OPTIONS: Currency[] = [
  CURRENCY_1,
  CURRENCY_2,
  CURRENCY_3,
  CURRENCY_4,
  CURRENCY_5,
  CURRENCY_6,
  CURRENCY_7,
  CURRENCY_8,
  CURRENCY_9,
];

export const PRIORITY_MAP = PRIORITY_OPTIONS.reduce((acc, curr) => {
  acc[curr.value] = curr;
  return acc;
}, {} as Record<PriorityValue, Priority>);

export const PRIO_COLORS = {
  H: PRIO1,
  M: PRIO2,
  L: PRIO3,
};

export const MD_EDITOR_PLUGINS = [
  "header",
  "fonts",
  "table",
  "link",
  "mode-toggle",
  "full-screen",
];

export const MD_EDITOR_CONFIG = {
  view: {
    menu: true,
    md: true,
    html: false,
  },
  canView: {
    menu: true,
    md: true,
    html: true,
    fullScreen: true,
    hideMenu: false,
  },
};

export const MD_EDITING_CONFIG = {
  view: {
    menu: false,
    md: true,
    html: false,
  },
  canView: {
    menu: false,
    md: true,
    html: false,
    fullScreen: false,
    hideMenu: false,
  },
};

export const MD_READ_ONLY_CONFIG = {
  view: {
    menu: false,
    md: false,
    html: true,
  },
  canView: {
    menu: false,
    md: false,
    html: true,
    fullScreen: false,
    hideMenu: false,
  },
};

export const theme = createMuiTheme({
  palette: {
    type: "light",
    primary: {
      main: PRIMARY_MAIN,
    },
    secondary: {
      light: grey[700],
      main: "#FDB915",
    },
  },
  typography: {
    fontFamily: '"Inter var", sans-serif',
  },
  props: {
    MuiButtonBase: {
      disableRipple: true,
    },
    MuiDialog: {
      transitionDuration: 100,
    },
  },
  overrides: {
    MuiButton: {
      root: {
        "&:hover": {
          transition: "none",
        },
      },
    },
  },
});

export const modalPopperIndex = theme.zIndex.modal + 100;
export const modalPopperAutocompleteIndex = modalPopperIndex + 100;
export const modalPopperAutocompleteModalIndex =
  modalPopperAutocompleteIndex + 100;
export const modalPopperWidth = 300;

export enum Key {
  Enter = 13,
  Escape = 27,
}

type validType = "revenue_cost" | "payment";
export const CheckStage = (stage: string, type: validType) => {
  const supportedMainStages = [
    "P_VS",
    "P_MDLR",
    "P_D",
    "P_MC",
    "P_M",
    "P_IC",
    "P_PBG",
    "P_LC",
    "P_TT",
    "P_FAT",
    "P_DS",
    "P_ABDA",
    "P_DC",
    "P_C",
    "P_L",
    "P_COM",
    "P_SITE",
    "P_ASC",
  ];
  const supportedSubStages = [
    "DS_DPL",
    "DS_SFRA",
    "DS_LSPS",
    "DS_VI",
    "DS_MG",
    "DS_KECI",
    "DS_SD",
    "DS_FDA",
    "DS_MIT",
  ];
  if (type === "revenue_cost") {
    return (
      supportedMainStages.includes(stage) || supportedSubStages.includes(stage)
    );
  } else {
    return supportedMainStages.includes(stage);
  }
};
